import styled from 'styled-components';

import { UpdateMessage } from 'libs/ui';

export const Content = styled.div`
  width: 590px;
  position: relative;
  margin: 0 0 1rem;
  form > div:last-child {
    margin-top: 20px;
  }
`;

export const Title = styled.p`
  border-bottom: solid 1px #595d64;
  padding: 0 0 15px 0;
  font-size: 20px;
  color: #fff;
  opacity: 0.6;
  &.nobrd{
    border: 0;
  }
`;

export const UpdateMessageBox = styled(UpdateMessage)`
  bottom: -40px;
  left: 100px;
`;
